import quillrAd from '../assets/quillr-ad.jpeg';
import reviseRadiologyDesktopAd from '../assets/revise-radiology-ad-desktop.png';
import reviseRadiologyMobileAd from '../assets/revise-radiology-ad-mobile.png';

export type SponsorAdDefinition = {
    id: string;
    name: string;
    href: string;
    imageSrc: string;
    mobileImageSrc?: string;
    alt: string;
};

// Both entries intentionally have one position in this list, giving them an
// equal chance of being selected each time a sponsored slot is mounted.
export const SPONSOR_ADS: readonly SponsorAdDefinition[] = [
    {
        id: 'quillr',
        name: 'Quillr.ai',
        href: 'https://quillr.ai/',
        imageSrc: quillrAd,
        alt: 'Quillr.ai AI reporting companion',
    },
    {
        id: 'revise-radiology',
        name: 'Revise Radiology',
        href: 'https://www.instagram.com/reviseradiology/',
        imageSrc: reviseRadiologyDesktopAd,
        mobileImageSrc: reviseRadiologyMobileAd,
        alt: 'Revise Radiology — helping radiologists pass their postgraduate exams first time',
    },
];

export function selectRandomSponsorAd(): SponsorAdDefinition {
    return SPONSOR_ADS[Math.floor(Math.random() * SPONSOR_ADS.length)];
}
